import { Outlet, useOutletContext } from "react-router-dom";

export default function Index() {
  const context = useOutletContext();
  return <div className="row flex-nowrap">
    <Outlet context={context} />
  </div>;
}
